// extracted by mini-css-extract-plugin
export default {"icon":"EmployeeWorkingHoursToggle--icon--4c2bef","toggleButton":"EmployeeWorkingHoursToggle--toggleButton--ceaaa6","container":"EmployeeWorkingHoursToggle--container--0da714"};